import React, { useState } from "react";
import { Form, Button, Modal } from "react-bootstrap";
import { AiOutlineSend } from "react-icons/ai";
import "./Contact.css"; // Import the styles

function ContactForm() {
    const [formData, setFormData] = useState({
        name: "",
        email: "",
        subject: "",
        message: "",
    });

    const [showModal, setShowModal] = useState(false);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({
            ...prev,
            [name]: value,
        }));
    };

    const handleClose = () => setShowModal(false);

    const handleSubmit = async (e) => {
        e.preventDefault();

        try {
            const response = await fetch("http://localhost:5000/send", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(formData),
            });

            if (response.ok) {
                // Clear form and show success modal
                setFormData({
                    name: "",
                    email: "",
                    subject: "",
                    message: "",
                });
                setShowModal(true);
            } else {
                alert("Failed to send message. Please try again.");
            }
        } catch (error) {
            console.error("Error:", error);
            alert("Something went wrong. Please check if the server is running.");
        }
    };

    return (
        <div className="contact-form-container">
            <Form onSubmit={handleSubmit}>
                <Form.Group controlId="formName">
                    <Form.Control
                        type="text"
                        placeholder="Your name"
                        name="name"
                        value={formData.name}
                        onChange={handleChange}
                        required
                        className="contact-input"
                    />
                </Form.Group>

                <Form.Group controlId="formEmail">
                    <Form.Control
                        type="email"
                        placeholder="Email address"
                        name="email"
                        value={formData.email}
                        onChange={handleChange}
                        required
                        className="contact-input"
                    />
                </Form.Group>

                <Form.Group controlId="formSubject">
                    <Form.Control
                        type="text"
                        placeholder="Subject"
                        name="subject"
                        value={formData.subject}
                        onChange={handleChange}
                        required
                        className="contact-input"
                    />
                </Form.Group>

                <Form.Group controlId="formMessage">
                    <Form.Control
                        as="textarea"
                        rows={5}
                        placeholder="Your message"
                        name="message"
                        value={formData.message}
                        onChange={handleChange}
                        required
                        className="contact-input"
                    />
                </Form.Group>

                <Button
                    variant="primary"
                    type="submit"
                    className="contact-btn"
                >
                    <AiOutlineSend /> &nbsp;Send Message
                </Button>
            </Form>

            <Modal show={showModal} onHide={handleClose} centered>
                <Modal.Header closeButton style={{ backgroundColor: "#1e1e28", color: "white", borderBottom: "1px solid #2d2d3a" }}>
                    <Modal.Title>Message Sent!</Modal.Title>
                </Modal.Header>
                <Modal.Body style={{ backgroundColor: "#1e1e28", color: "white" }}>
                    Thank you for reaching out. We'll contact you soon!
                </Modal.Body>
                <Modal.Footer style={{ backgroundColor: "#1e1e28", borderTop: "1px solid #2d2d3a" }}>
                    <Button variant="secondary" onClick={handleClose}>
                        Close
                    </Button>
                </Modal.Footer>
            </Modal>
        </div>
    );
}

export default ContactForm;
